import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Home from "./pages/Home";

import Header from "./components/Header";
import Footer from "./components/Footer";
import SearchResults from "./components/SearchResults";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import UserProfile from "./pages/UserProfile";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/Dashboard";
import AdminProducts from "./admin/Products";
import ProductForm from "./admin/ProductForm";
import Categories from "./admin/Categories";
import Orders from "./admin/Orders";
import Users from "./admin/Users";
import ProductView from "./components/ProductView";
import WishlistPage from "./components/WishlistPage";
import CheckoutPage from "./components/CheckoutPage";
import MyOrders from "./components/MyOrders";
import EditProfile from "./components/EditProfile";
import SingleCategoryPage from "./components/SingleCategoryPage";
import Deals from "./components/Deals";
import About from "./components/About";
import Contact from "./components/Contact";
import AllCategory from "./components/AllCategory";
import AllProducts from "./components/AllProducts";
import ThankYou from "./components/ThankYou";
import CheckCustomer from "./components/CheckCustomer";
import CompanyForm from "./admin/CompanyForm";
import BannerForm from "./admin/BannerForm";
import BrandForm from "./admin/BrandForm";
import BrandList from "./admin/BrandList";

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes with Header */}
          <Route
            path="/"
            element={
              <>
                <Header />
                <Home />
                <Footer />
              </>
            }
          />
          <Route
            path="/checkuser"
            element={
              <>
                <Header />
                <CheckCustomer />
                <Footer />
              </>
            }
          />
          <Route
            path="*"
            element={
              <>
                <Header />
                <h2>Sorry This Page is not added yet</h2>
                <Footer />
              </>
            }
          />
          <Route
            path="/search"
            element={
              <>
                <Header />
                <SearchResults />
                <Footer />
              </>
            }
          />
          <Route
            path="/checkout"
            element={
              <>
                <Header />
                <CheckoutPage />
                <Footer />
              </>
            }
          />
          <Route
            path="/thank-you"
            element={
              <>
                <Header />
                <ThankYou />
                <Footer />
              </>
            }
          />
          <Route
            path="/login"
            element={
              <>
                <Header />
                <Login />
                <Footer />
              </>
            }
          />
<Route
path="/profile/edit"
element={
  <>
    <Header />
    <EditProfile />
    <Footer />
  </>
}
/>
<Route
path="/all-categories"
element={
  <>
    <Header />
    <AllCategory />
    <Footer />
  </>
}
/>
<Route
path="/register"
element={
  <>
    <Header />
                <Register />
                <Footer />
              </>
            }
          />

<Route
path="/all-products"
element={
  <>
    <Header />
    <AllProducts />
    <Footer />
  </>
}
/>

          <Route
            path="/orders"
            element={
              <>
                <Header />
                <MyOrders />
                <Footer />
              </>
            }
          />
          <Route path="/categories/:id" element={<> <Header /> <SingleCategoryPage /> <Footer /> </>} />
          <Route path="/deals" element={<> <Header /> <Deals /> <Footer /> </>} />
          <Route path="/about" element={<> <Header /> <About /> <Footer /> </>} />
          <Route path="/contact" element={<> <Header /> <Contact /> <Footer /> </>} />
          <Route
            path="/product/:id"
            element={
              <>
                <Header />
                <ProductView />
                <Footer />
              </>
            }
          />
          <Route
            path="/wishlist"
            element={
              <>
                <Header />
                <WishlistPage />
                <Footer />
              </>
            }
          />
          <Route
            path="/profile"
            element={
              <>
                <Header />
                <UserProfile />
                <Footer />
              </>
            }
          />

          {/* Admin Routes with AdminLayout */}
          <Route
            path="/admin/*"
            element={
              <PrivateRoute adminOnly={true}>
                <AdminLayout />
              </PrivateRoute>
            }
          >
            
            <Route path="" element={<AdminDashboard />} />
            <Route path="company-info" element={<CompanyForm />} />
            <Route path="header-banner" element={<BannerForm />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="products/new" element={<ProductForm />} />
            <Route path="products/:id/edit" element={<ProductForm />} />
            <Route path="categories" element={<Categories />} />
            <Route path="orders" element={<Orders />} />
            <Route path="users" element={<Users />} />
            <Route path="brands" element={<BrandList />} />
            <Route path="brands/create" element={<BrandForm />} />
            <Route path="brands/:id/edit" element={<BrandForm />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}
